/* eslint-disable no-eval */
import { createHook, createStore, defaults } from 'react-sweet-state';

defaults.devtools = true;

export const initialState = {
  /**
   * PARAMETROS GENERALES
   */
  idPoliza: null,
  codProducto: null,

  /**
   * PARAMETROS LINK COBRO
   */
  isFromLinkCobro: false,
  tokenCorreo: null,
  sessionId: null,
  from: 'default',
  /**
   * ESTADOS FORMULARIO
   */
  permiteContinuar: true,
  tieneTokenActivo: true,
  isCancelandoToken: false,
  showFormPago: false,
  showFormCancelarTokens: false,
  /**
   * ENVIO DE LINK DE COBRO
   */
  enviandoLinkCobro: false,
};

const actions = {
  setState: (state = {}) => {
    return ({ setState, getState }) => {
      setState({ ...getState(), ...state });
    };
  },
  cancelarTokenCorreo: (state) => {
    return ({ setState, ...rest }) => {
      console.log(rest);
      setState({ isCancelandoToken: state });
    };
  },
};

const PagoStore = createStore({
  name: 'PagoPageState',
  initialState: initialState,
  actions: actions,
});

const hook = createHook(PagoStore);

export const usePantallaPago = () => {
  return hook()[0];
};

export const useAccionesPantallaPago = () => {
  return hook()[1];
};
